<template>
  <PageHeader />
  <BaseCard>
    <template v-if="data?.data">
      <div class="flex justify-end">
        <button
          type="button"
          class="bg-primary border-background hover:bg-primary/70 text-primary-fg relative inline-flex cursor-pointer items-center rounded-lg border px-3 py-1 text-sm font-medium focus:z-10 focus:outline-none"
          @click="onAcceptImport"
        >
          Finish Import
        </button>
      </div>
      <ProductImportTable :rows="data?.data.rows" />
    </template>
  </BaseCard>
</template>

<script setup lang="ts">
const props = defineProps<{
  importId: string
}>()

const importId = toRef(props, "importId")

const { data } = useImport(importId)

const isSubmitting = ref(false)
const onAcceptImport = async () => {
  isSubmitting.value = true
  try {
    await acceptImport(props.importId)
  } catch (error) {
    logError(error)
    toast.error("Failed to accept import")
  } finally {
    isSubmitting.value = false
  }
}
</script>
